import { supabase } from '../../shared/supabase/supabaseClient';
import { customerPortalBaseUrl } from '../../shared/customerPortalUrl';

const PORTAL_BASE = customerPortalBaseUrl();

export async function fetchSalePickupTrackingUrl(saleId: string): Promise<string | null> {
  const { data, error } = await supabase.rpc('get_sale_pickup_tracking_url', {
    p_sale_id: saleId,
  });
  if (error) {
    console.warn('[pickupTracking] get_sale_pickup_tracking_url', error.message);
    return null;
  }
  const path = (data as { tracking_url_path?: string | null } | null)?.tracking_url_path?.trim();
  if (!path) return null;
  return `${PORTAL_BASE}${path.startsWith('/') ? path : `/${path}`}`;
}
